/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CreateFeedbackTypeRequest } from '../models/create-feedback-type-request';
import { FeedbackTypeResponse } from '../models/feedback-type-response';
import { GenericResponse } from '../models/generic-response';
import { GetFeedbackTypeResponse } from '../models/get-feedback-type-response';
import { UpdateFeedbackTypeRequest } from '../models/update-feedback-type-request';

/**
 * feedback type apis
 */
@Injectable({ providedIn: 'root' })
export class FeedbackTypeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllFeedbackType()` */
  static readonly GetAllFeedbackTypePath = '/api/v1/feedback-types';

  /**
   * Get list of feedback types.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllFeedbackType()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllFeedbackType$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields:
       * - type
       * - name
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetFeedbackTypeResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FeedbackTypeService.GetAllFeedbackTypePath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('search', params.search, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetFeedbackTypeResponse>;
        })
      );
  }

  /**
   * Get list of feedback types.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllFeedbackType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllFeedbackType(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields:
       * - type
       * - name
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<GetFeedbackTypeResponse> {
    return this.getAllFeedbackType$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<GetFeedbackTypeResponse>
        ): GetFeedbackTypeResponse => r.body
      )
    );
  }

  /** Path part for operation `createFeedbackType()` */
  static readonly CreateFeedbackTypePath = '/api/v1/feedback-types';

  /**
   * Create new feedback type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createFeedbackType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFeedbackType$Response(
    params: {
      body: CreateFeedbackTypeRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<FeedbackTypeResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FeedbackTypeService.CreateFeedbackTypePath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<FeedbackTypeResponse>;
        })
      );
  }

  /**
   * Create new feedback type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createFeedbackType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFeedbackType(
    params: {
      body: CreateFeedbackTypeRequest;
    },
    context?: HttpContext
  ): Observable<FeedbackTypeResponse> {
    return this.createFeedbackType$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<FeedbackTypeResponse>): FeedbackTypeResponse =>
          r.body
      )
    );
  }

  /** Path part for operation `getFeedbackTypeById()` */
  static readonly GetFeedbackTypeByIdPath = '/api/v1/feedback-types/{id}';

  /**
   * fetch feedback type by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeedbackTypeById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeedbackTypeById$Response(
    params: {
      /**
       * The feedback type's id that needs to be updated
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<FeedbackTypeResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FeedbackTypeService.GetFeedbackTypeByIdPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<FeedbackTypeResponse>;
        })
      );
  }

  /**
   * fetch feedback type by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeedbackTypeById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeedbackTypeById(
    params: {
      /**
       * The feedback type's id that needs to be updated
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<FeedbackTypeResponse> {
    return this.getFeedbackTypeById$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<FeedbackTypeResponse>): FeedbackTypeResponse =>
          r.body
      )
    );
  }

  /** Path part for operation `deleteFeedbackType()` */
  static readonly DeleteFeedbackTypePath = '/api/v1/feedback-types/{id}';

  /**
   * Delete feedback type by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteFeedbackType()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFeedbackType$Response(
    params: {
      /**
       * The feedback type's id that needs to be deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FeedbackTypeService.DeleteFeedbackTypePath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * Delete feedback type by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteFeedbackType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFeedbackType(
    params: {
      /**
       * The feedback type's id that needs to be deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.deleteFeedbackType$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `updateFeedbackType()` */
  static readonly UpdateFeedbackTypePath = '/api/v1/feedback-types/{id}';

  /**
   * Update feedback type by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFeedbackType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFeedbackType$Response(
    params: {
      /**
       * The feedback type's id that needs to be updated
       */
      id: number;
      body: UpdateFeedbackTypeRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<FeedbackTypeResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FeedbackTypeService.UpdateFeedbackTypePath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<FeedbackTypeResponse>;
        })
      );
  }

  /**
   * Update feedback type by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateFeedbackType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFeedbackType(
    params: {
      /**
       * The feedback type's id that needs to be updated
       */
      id: number;
      body: UpdateFeedbackTypeRequest;
    },
    context?: HttpContext
  ): Observable<FeedbackTypeResponse> {
    return this.updateFeedbackType$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<FeedbackTypeResponse>): FeedbackTypeResponse =>
          r.body
      )
    );
  }
}
